import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://61d4acb8d5bd2cc247c464923b7fe65e@o4507893789229056.ingest.de.sentry.io/4507895186456656',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  ignoreErrors: [/Network Error/i, /Fetch Error/i, /AxiosError/i],
  enabled: import.meta.env.MODE !== 'development',
  tracesSampleRate: 0.1,
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/api-sandbox\.synapsai\.ai/,
    /^https:\/\/api\.synapsai\.ai/,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
});
